import React from 'react';
import { Tabs, Popover, Collapse } from 'antd';

import { Author } from '../api/Author';
import { AuthorRecommendation } from '../api/AuthorRecommendation';
import { AuthorInfoDisplay } from './AuthorInfoDisplay';

interface IBridgerRecs {
    name: string;
    authorRecs?: AuthorRecommendation;
}

export const BridgerRecommendations = (props: IBridgerRecs) => {
    const { name, authorRecs } = props;

    const labelInfo: { [key: string]: string } = {
        simMethod: 'Authors who use similar methods',
        simTask: 'Authors who work on similar tasks',
        simMethod_distTask: 'Authors who use similar methods, but work on less similar tasks',
        simTask_distMethod: 'Authors who work on similar tasks, but use less similar methods',
        simspecter: 'Authors with similar papers (non-Bridger recommendations)',
    };

    const labelHeaders: { [key: string]: string } = {
        simMethod: 'Similar Method',
        simTask: 'Similar Task',
        simMethod_distTask: 'Similar Method, Less Similar Task',
        simTask_distMethod: 'Similar Task, Less Similar Method',
        simspecter: 'Generally Similar Authors',
    };

    if (!authorRecs) return null;
    return (
        <div>
            <h4>Authors Similar to {name}</h4>
            {/* I needed to put a hack in `index.css` to make the Tabs work */}
            <Tabs
                defaultActiveKey="1"
                items={Object.entries(authorRecs).map((item: [string, Author[]], index) => {
                    const [label, recs] = item;
                    const key: string = (index + 1).toString();
                    return {
                        label: <Popover content={labelInfo[label]}>{labelHeaders[label]}</Popover>,
                        key: key,
                        children: (
                            <div>
                                <h5>{labelInfo[label]}</h5>
                                <Collapse>
                                    {recs.map((rec) => {
                                        // TODO figure out what is happening with missing names (rec.name is null)
                                        return rec.name ? (
                                            <Collapse.Panel header={rec.name} key={rec.id}>
                                                <AuthorInfoDisplay id={rec.id} />
                                            </Collapse.Panel>
                                        ) : null;
                                    })}
                                </Collapse>
                            </div>
                        ),
                    };
                })}
            />
        </div>
    );
};
